<template lang="pug">
    .tree-node(@click.stop="fetchCcloneDetails(cclone.id)")
        .tree-node__info
            .l-flex-row.tree-node__top-info
                .tree-node__id.cclone-id {{ cclone.id }}
            .tree-node__label.cclone-label(:title="cclone.label") {{ cclone.label }}
        .cclone-mode {{ ccloneMode }}
</template>

<script>
//avoid repeating namespace for each store action/mutation/getter/state
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
    name: 'CCloneItem',

    props: {
        cclone: { type: Object, required: true }
    },

    data() {
        return {}
    },

    computed: {
        // Call to state
        ...mapState('ui/cclone', {
            selectedCcloneId: state => state.selectedCcloneId
        }),

        ccloneMode() {
            let cmode = ''
            if (this.cclone.settings.hasOwnProperty('3rdParty') && this.cclone.settings.hasOwnProperty('1stParty')) cmode = '1st and 3rd Party'
            else if (this.cclone.settings.hasOwnProperty('3rdParty')) cmode = '3rd Party'
            else if (this.cclone.settings.hasOwnProperty('1stParty')) cmode = '1st Party'
            return cmode
        }
    },

    methods: {
        // Call to actions
        ...mapActions('data/cclone', ['retrieveCcloneDetails']),
        // Call to mutations
        ...mapMutations('ui/builder', ['setCcloneFormula']),
        ...mapMutations('ui/cclone', ['setSelectedCclone']),
        ...mapMutations('data/cclone', ['setDecisionTree']),

        fetchCcloneDetails(ccloneId) {
            this.setDecisionTree({ status: null, image: null })
            this.setCcloneFormula({ formula: null })

            if (this.selectedCcloneId !== null && this.selectedCcloneId === ccloneId) {
                this.setSelectedCclone({ id: null })
            } else {
                this.setSelectedCclone({ id: ccloneId })
                this.retrieveCcloneDetails({ ccloneId })
            }
        }
    }
}
</script>
